import { media } from '@bb/contracts';
import type { MediaMime, MediaPreset, MediaVersionView } from '../../api/client.ts';

export const MIME_LABEL: Record<MediaMime, string> = { 'image/png': 'PNG', 'image/jpeg': 'JPEG', 'image/gif': 'GIF', 'image/webp': 'WebP' };

export const formatBytes = (bytes: number) => (bytes >= 1024 * 1024 ? `${(bytes / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(bytes / 1024))} KB`);

export const PRESETS = Object.entries(media.RENDITION_PRESETS).map(([key, value]) => ({ key: key as MediaPreset, ...value }));

/** The small image for grids: the ready thumbnail, else the original. */
export const thumbUrl = (version: MediaVersionView) => version.renditions.thumb?.url ?? version.url;

/** File name without the extension, as the default asset name. */
export const nameOfFile = (fileName: string) => fileName.replace(/\.[^.]+$/, '').trim() || fileName;
